import { render, staticRenderFns } from "./HeadingInformation.vue?vue&type=template&id=0c04f2a4&"
import script from "./HeadingInformation.vue?vue&type=script&lang=js&"
export * from "./HeadingInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports